import { FamilyRelationshipPicker } from "UserProfile/Family/Relationships/FamilyRelationshipPicker";
import { AnimatePresence } from "framer-motion";

export default function RelationshipModalOnly({
  show,
  setShow,
  userID,
  addNewHouseholdRespondent,
}) {
  const closeRelationshipModal = () => {
    setShow(false);
  };

  const handleAddNewHouseholdRespondent = (newUser, newHouseholdID) => {
    addNewHouseholdRespondent(newUser, newHouseholdID);
    closeRelationshipModal();
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <FamilyRelationshipPicker
          profileUserID={userID}
          closeOverlay={closeRelationshipModal}
          onFinish={handleAddNewHouseholdRespondent}
        />
      )}
    </AnimatePresence>
  );
}
